import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const Container = styled.div`
  img {
    vertical-align: bottom;
    max-width: 100%;
    height: auto;
    display: block;
    object-fit: contain;

    ${media.md`
      max-height: 77px;
      max-width: unset;
    `}
  }
`;
